import React, { useLayoutEffect } from 'react';
import { Platform } from 'react-native';

import { useResponsive, useSafeExpoNavigation, useSafeNavigation } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

import { LoadingAnimation } from '../../components';
import { AccountSignedOutMessage } from '../../components/Account';
import { useIsLoggedIn, useIsLoggingIn } from '../../context/AuthMachine';
import { ProfileScreen } from '../ProfileScreen';
import { AccountScreenContent } from './AccountScreen.content';

export const AccountScreen = () => {
  const { currentBreakpoint } = useResponsive();
  const navigation = useSafeNavigation();
  const expoNavigation = useSafeExpoNavigation();
  const isExpoRouterEnabled = useIsExpoRouterEnabled();

  const isLoggedIn = useIsLoggedIn();
  const isLoggingIn = useIsLoggingIn();

  const setOptions = navigation?.setOptions ?? expoNavigation?.setOptions;

  useLayoutEffect(() => {
    setOptions?.({
      headerShown: !isExpoRouterEnabled && !currentBreakpoint.isXS,
    });
  }, [setOptions, currentBreakpoint.isXS, isExpoRouterEnabled]);

  if (isLoggingIn) return <LoadingAnimation />;

  if (!isLoggedIn && Platform.OS === 'web') {
    return <AccountSignedOutMessage />;
  }

  if (!currentBreakpoint.isXS && isLoggedIn) {
    return <ProfileScreen />;
  }

  return <AccountScreenContent />;
};
